import React from 'react';
export function Footer() {
  return <footer className="bg-deco-beige py-12 px-4 text-center border-t border-deco-forest/10" data-id="element-71" data-mp="32wd2qgad7ltj">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-3" data-id="element-72" data-mp="3ggtx2ezk5d3n">
        <p className="font-serif text-2xl text-deco-forest font-semibold" data-id="element-73" data-mp="32ovwisjwwpj3">
          Deco Emprende
        </p>
        <p className="font-serif italic text-base text-deco-brick" data-id="element-74" data-mp="36q92r3qx2uqj">
          Falso Vitral Deco
        </p>
        <div className="w-10 h-px bg-deco-aqua my-2" data-id="element-75" data-mp="3ufjwi19unov6" />
        <p className="text-[11px] text-deco-forest/45" data-id="element-76" data-mp="38h7nghhhuo4">
          © {new Date().getFullYear()} Deco Emprende. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}